import React from 'react';
import Select, {components} from 'react-select';

const Folders = ({setSelected, folders, icon}) => {
  const styles = (width, size, background, color) => ({
    container: (base) => ({
      ...base,
      width: 30,
      height: '20px',
    }),
    menu: (provided) => ({
      ...provided,
      width: '200px',
      zIndex: 9999,
      marginLeft: '-100px',
    }),
    option: (provided) => ({
      ...provided,
      borderBottom: '1px solid #cfcfcf',
      fontSize: 14,
      textTransform: 'capitalize',
      '&:hover': {
        background: '#373737',
        color: '#FFF',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 2,
    }),
    control: () => ({
      display: 'flex',
      borderRadius: 0,
      border: 'none',
      backgroundColor: background || undefined,
      color: color || undefined,
      cursor: 'pointer',
      alignItems: 'center',
    }),

    placeholder: () => ({
      display: 'none',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: size === 'large' ? 12 : 10,
      display: 'none',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    singleValue: (base) => ({
      ...base,
      color: color || undefined,
      display: 'none',
    }),
  });

  return (
    <Select
      menuPlacement="top"
      styles={styles()}
      onChange={(option) => {
        setSelected(option);
      }}
      menuPortalTarget={document.querySelector('body')}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option._id}
      options={folders}
      isSearchable={false}
      isOptionDisabled={(option) => option.isDisabled}
      components={{
        Control: ({children, ...rest}) => (
          <components.Control {...rest}>
            <img src={icon} height="16" alt="" />
            {children}
          </components.Control>
        ),
      }}
    />
  );
};

export default Folders;
